import { datetimeFormat, convertDateTimeToUTC } from '../helpers';
import {
	CONTENT_TYPE,
} from '../../../enums/navigationMenu';
import {
	PERIOD_STATUS_LABELS,
	PERIOD_STATUS_COLOR,
} from '../../../enums/status';

// From Api section
export const transformedNavigationMenuItem = (item = {}) => {
	return {
		id: item.id || null,
		name: item.name || '',
		slug: item.slug || '',
		isActive: item.is_active || false,
		previewPeriod: {
			label: PERIOD_STATUS_LABELS[item.period] || '',
			color: PERIOD_STATUS_COLOR[item.period] || '',
		},
		period: item.period || '',
		previewStartAt: item.start_at ? datetimeFormat(item.start_at) : null,
		previewEndAt: item.end_at ? datetimeFormat(item.end_at) : null,
		startAt: item.start_at,
		endAt: item.end_at,
	};
};

export const transformedNavigationMenuItemList = (items = []) => {
	return items.map((item) => transformedNavigationMenuItem(item));
};

export const transformedNavigationMenuItemDetailBadge = (badges = {}) => {
	return {
		id: badges.id,
		name: badges.name || '',
		type: badges.type || '',
		subType: badges.sub_type || '',
		isActive: badges.is_active || false,
		isLabelVisible: badges.is_label_visible || false,
	};
};

export const transformedNavigationMenuItemDetailContent = (content = {}) => {
	const item0 = content.items?.[0] || {};
	const media0 = content.media?.[0] || {};
	const name = item0.name // Product
		|| item0.name_en // Category
		|| '';
	const thumbnail = item0.images?.[0]?.urls?.thumbnail // Category and Product
		|| item0.files?.[0]?.urls?.thumbnail // Banner
		|| null;
	const id = item0?.files?.[0]?.id // Banner
		|| item0?.id // Category and Product
		|| null;
	return {
		id: content.id || null,
		type: content.type || '',
		titleEn: content.name_en || '',
		titleTh: content.name_th || '',
		isLowestPriceVisible: content.is_lowest_price_visible || false,
		imagePreviewId: media0?.id || null,
		imagePreviewUrl: media0?.urls?.thumbnail || null,
		badgeLabels: content.labels?.map((label) => transformedNavigationMenuItemDetailBadge(label)) || [],
		contentItem: {
			id,
			name,
			thumbnail,
			customUrl: item0?.link || '',

			// For banner preview
			imageUrls: item0?.files?.[0]?.urls || {},
		},
	};
};

export const transformedNavigationMenuItemDetail = (item = {}) => {
	const items = item.contents?.map((content) => {
		if (!content?.items?.length) {
			return null;
		}

		return transformedNavigationMenuItemDetailContent(content);
	})?.filter((cItem) => cItem !== null) || [];
	return {
		id: item.id || null,
		name: item.name || '',
		isActive: item.is_active ? 1 : 0,
		titleTh: item.title_th || '',
		titleEn: item.title_en || '',
		startDate: new Date(datetimeFormat(item.start_at)),
		startTime: datetimeFormat(item.start_at, 'HH:mm'),
		endDate: new Date(datetimeFormat(item.end_at)),
		endTime: datetimeFormat(item.end_at, 'HH:mm'),
		items,
	};
};
// End From Api section

// To Api section
export const transformedLabelToApi = (badge = {}) => {
	return {
		label_id: badge.id,
		is_label_visible: badge.isLabelVisible ? 1 : 0,
	};
};

export const transformedBannerToApi = (banner = {}) => {
	return {
		file_id: banner.id,
		link: banner.customUrl,
	};
};

export const transformedMediaToApi = (media = {}) => {
	return {
		file_id: media.imagePreviewId,
	};
};

export const transformedNavigationMenuContentToApi = (item = {}, index = 0) => {
	const contentItem = item?.contentItem || {};
	return {
		id: item.id || null,
		type: item.type,
		name_en: item.titleEn || '',
		name_th: item.titleTh || '',
		is_visible: true,
		is_lowest_price_visible: item.isLowestPriceVisible || false,
		category_ids: item.type === CONTENT_TYPE.category ? [contentItem?.id] : null,
		product_ids: item.type === CONTENT_TYPE.products ? [contentItem?.id] : null,
		labels: item.badgeLabels?.map((label) => transformedLabelToApi(label)) ?? [],
		media: item.imagePreviewId ? transformedMediaToApi(item) : null,
		custom_url: item.customUrl || null,
		banners: item.type === CONTENT_TYPE.banner
			? [transformedBannerToApi(item.contentItem)]
			: null,
		order: index,
	};
};

export const transformedNavigationMenuToApi = (navigationMenu = {}) => {
	return {
		name: navigationMenu.name,
		is_active: Boolean(navigationMenu.isActive),
		content_type: navigationMenu.contentType || '',
		title_th: navigationMenu.titleTh || '',
		title_en: navigationMenu.titleEn || '',
		start_at: convertDateTimeToUTC(navigationMenu.startDate, navigationMenu.startTime),
		end_at: convertDateTimeToUTC(navigationMenu.endDate, navigationMenu.endTime),
		contents: navigationMenu.items?.map((item, index) => transformedNavigationMenuContentToApi(item, index)) ?? [],
	};
};
// End To Api section